<app-header></app-header>
<div class="router-container"> 
    <router-outlet></router-outlet>
</div>
<app-footer></app-footer>
